import React, { useEffect, useState } from 'react';

function PWAInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowPrompt(true);
    });
  }, []);

  const handleInstallClick = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the install prompt');
        } else {
          console.log('User dismissed the install prompt');
        }
        setDeferredPrompt(null);
        setShowPrompt(false);
      });
    }
  };

  return (
    showPrompt && (
      <div style={{
        position: 'fixed',
        bottom: '70px',
        left: '10%',
        width: '80%',
        backgroundColor: '#4caf50',
        color: 'white',
        padding: '10px',
        textAlign: 'center',
        borderRadius: '5px',
        zIndex: 1000
      }}>
        <p>Installez cette application pour une meilleure expérience.</p>
        <button onClick={handleInstallClick} style={{ marginTop: '5px' }}>Installer</button>
      </div>
    )
  );
}

export default PWAInstallPrompt;